import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Flex,
  Button,
  Text,
  Box,
} from '@chakra-ui/react';
import DataBox from '../../components/databox';

const ViewAdminModal = ({ isOpen, onClose, admin }) => {
  if (!admin) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minH={'200px'}
        maxW={'500px'}
        borderRadius={16}
        padding={4}
        gap={8}
      >
        <ModalBody display={'flex'} flexDirection={'column'} gap={6}>
          <Text
            fontFamily={'PlusJakartaSansSemiBold'}
            fontSize={'24px'}
            lineHeight={'32px'}
            textTransform={'capitalize'}
            color={'#000000'}
          >
            Employee Details
          </Text>
          <Box height="1px" width="100%" bg="#8A8F9333" mx="auto" />
          <Flex direction={'column'} gap={4}>
            <Flex gap={4}>
              <DataBox label={'First Name'} data={admin?.first_name || '-'} />
              <DataBox label={'Last Name'} data={admin?.surname || '-'} />
            </Flex>
            <DataBox label={'Email'} data={admin?.email_address || '-'} />
            <DataBox label={'Role'} data={admin?.authUser?.role || '-'} />
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Flex w={'100%'} justify={'flex-end'}>
            <Button
              bg={'#000000'}
              color="#FFFFFF"
              borderRadius={8}
              paddingInline={16}
              textTransform={'uppercase'}
              onClick={onClose}
            >
              Close
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ViewAdminModal;
